import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MenuItem } from 'primeng/api';
import { PanelMenuModule } from 'primeng/panelmenu';

// Component
import { AppMenuitemComponent } from './app.menuitem';

// Service
import { MenuService } from '@/Services/menu.service';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, PanelMenuModule, AppMenuitemComponent],
  template: `
    <ul class="layout-menu h-full p-5">
      @for (item of model; track $index) {
      <ng-container>
        @if (!item.separator) {
          <li
            app-menuitem
            [item]="item"
            [index]="$index"
            [root]="true"
          ></li>
        }
        @if (item.separator) {
          <li class="menu-separator"></li>
        }
      </ng-container>
      }
    </ul>
  `,
})
export class AppMenuComponent implements OnInit {
  model: MenuItem[] = [];
  menuService = inject(MenuService);

  ngOnInit() {
    this.model = this.menuService.getMenu();
  }
}
